export default __webpack_public_path__ + "static/media/ic_rupee.db6f6e63.svg";